const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-819ac789-3d01-4e9b-ba16-527923fa082c {\n        fill: #5e3524;\n      }\n\n      .uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee {\n        stroke-width: .75px;\n      }\n\n      .uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee, .uuid-30bd92f7-536f-406f-a448-7b6e811b55d6 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-30bd92f7-536f-406f-a448-7b6e811b55d6 {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-de670890-b3dc-464c-8c93-4c9916dc7992",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-819ac789-3d01-4e9b-ba16-527923fa082c",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-3e73ac4d-b3f0-4d0e-9f44-6fc0d1563267",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-30bd92f7-536f-406f-a448-7b6e811b55d6",
  d: "M38.37,17.34l-5.94-5.96c-3.29-3.01-6.86-2.09-7.31-1.96-.03.01-.06.03-.09.05-1.48,1.36-1.88,1.5-3.07,1.52-1.32.02-1.73-.16-3.07-1.52-.03-.02-.06-.03-.08-.05-.44-.13-4.01-1.06-7.31,1.96l-5.94,5.96c-.11.11-.11.29,0,.4l5.22,5.09c.11.1.27.11.38.01l2.4-2.08c.06-.05.16,0,.15.07l-.81,12.99c-.01.16.12.3.28.3h17.57c.16,0,.29-.14.28-.3l-.81-12.96c0-.09.1-.15.17-.09l2.38,2.06c.11.1.28.09.38-.01l5.22-5.09c.11-.11.11-.29,0-.4Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee",
  x1: 7.1,
  y1: 15.79,
  x2: 12.75,
  y2: 21.45
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee",
  x1: 36.86,
  y1: 15.82,
  x2: 31.21,
  y2: 21.48
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee",
  d: "M16.8,9.18s0,3.96,5.12,3.96,5.12-3.96,5.12-3.96"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-b63fe3f1-795e-4725-9cfa-b5f9b6123aee",
  x1: 13.02,
  y1: 31.75,
  x2: 30.9,
  y2: 31.75
}));
function SvgRepozeIconCategoryClothing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryClothing);
export default __webpack_public_path__ + "static/media/repoze_icon_category-clothing.e2ef8429e8060b3ac261cfecab9700bb.svg";
export { ForwardRef as ReactComponent };